var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"np-module-container np-slim-box"},[_c('message',{attrs:{"location":'TOP_STICKY'}}),_c('h2',[_vm._v(_vm._s(_vm.npContent('activites')))]),_c('timeline',{attrs:{"data":_vm.timelineList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }